export enum TableauEmbedContentActionsTypes {
  SET_INIT = 'tableau_embed_content/set_init',
  SET_TABLEAU_EMBED_CONTENT_FORM = 'tableau_embed_content/set_form',
  SET_TABLEAU_EMBED_CONTENT_FORM_KEY_VALUE = 'tableau_embed_content/set_form_key_value',
  SET_TABLEAU_EMBED_CONTENT_FORM_KEYS_VALUES = 'tableau_embed_content/set_form_keys_values',
}

// Interfaces

interface SetInitAction {
  type: TableauEmbedContentActionsTypes.SET_INIT;
  payload: boolean;
}

interface SetTableauEmbedContentFormAction {
  type: TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM;
  payload: any;
}

interface SetTableauEmbedContentFormKeyValueAction {
  type: TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM_KEY_VALUE;
  payload: {
    key: string;
    value: any;
  }
}

interface SetTableauEmbedContentFormKeysValuesAction {
  type: TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM_KEYS_VALUES;
  payload: any;
}

// Functions

export function setInit(init: boolean): SetInitAction {
  return {
    type: TableauEmbedContentActionsTypes.SET_INIT,
    payload: init,
  }
}

export function setTableauEmbedContentForm(form: any): SetTableauEmbedContentFormAction {
  return {
    type: TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM,
    payload: form,
  }
}

export function setTableauEmbedContentFormKeyValue(key: string, value: any): SetTableauEmbedContentFormKeyValueAction {
  return {
    type: TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM_KEY_VALUE,
    payload: {
      key,
      value,
    }
  }
}

export function setTableauEmbedContentFormKeysValues(
  keys: string[],
  values: any[]
): SetTableauEmbedContentFormKeysValuesAction {
  const payload = keys.reduce((acc: any, key, index) => {
    acc[key] = values[index];
    return acc;
  }, {});

  return {
    type: TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM_KEYS_VALUES,
    payload: payload,
  }
}

export type TableauEmbedContentActions =
  | SetInitAction
  | SetTableauEmbedContentFormAction
  | SetTableauEmbedContentFormKeyValueAction
  | SetTableauEmbedContentFormKeysValuesAction;
